import React, {useMemo} from 'react';
import {useTable, usePagination, useFilters} from 'react-table';
import {Table} from 'semantic-ui-react';
import {Filter, DefaultColumnFilter} from '../../common/components/tableFilters';
import TablePaginator from '../../common/components/reactTablePagination';

const columnsTable = [
  {
    'Header': 'Agencia',
    'accessor': 'agencyName',
  },
  {
    'Header': 'Pedido',
    'accessor': 'orders',
    'disableFilters': true,
  },
  {
    'Header': 'Atendido',
    'accessor': 'ordersServed',
    'disableFilters': true,
  },
  {
    'Header': 'Tasa',
    'accessor': 'serviceFee',
    'disableFilters': true,
    'Cell': ({row}) => `${row.original.serviceFee}%`,
  },
];

const ServiceReportPartTable = ({list, linesSize}) => {
  const data = useMemo(() => list, list);
  const columns = useMemo(() => columnsTable, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 10},
    },
    useFilters,
    usePagination,
  );

  return (
    <>
      <Table className='interactive' compact striped {...getTableProps()}>
        <Table.Header>
          {headerGroups.map((headerGroup) => (
            <Table.Row key='headers' {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <Table.HeaderCell
                  key={`title-${index}`}
                  textAlign='center'
                  {...column.getHeaderProps()}
                >
                  {column.render('Header')}
                </Table.HeaderCell>
              ))}
            </Table.Row>
          ))}
          {headerGroups.map((headerGroup) => (
            <Table.Row key='filters' id='filters'>
              {headerGroup.headers.map((column, index) => (
                <Table.HeaderCell key={`filter-${index}`} textAlign='center'>
                  <Filter column={column} />
                </Table.HeaderCell>
              ))}
            </Table.Row>
          ))}
        </Table.Header>
        <Table.Body {...getTableBodyProps()}>
          {!page.length && (
            <Table.Row>
              <Table.Cell colSpan={12} textAlign='center'>
                No hay datos disponibles
              </Table.Cell>
            </Table.Row>
          )}
          {page.length > 0 &&
            page.map((row, i) => {
              prepareRow(row);
              return (
                <Table.Row key={i} {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <Table.Cell textAlign='center' {...cell.getCellProps()}>
                        {cell.render('Cell')}
                      </Table.Cell>
                    );
                  })}
                </Table.Row>
              );
            })}
        </Table.Body>
      </Table>
      <TablePaginator
        data={data}
        canPreviousPage={canPreviousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canNextPage={canNextPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
        linesSize={linesSize}
      />
    </>
  );
};

export default ServiceReportPartTable;
